import { GetGoalsResponse } from '@src/features/goals/types/get-goals-response';
import { api } from '@src/lib/api-client';
import { QueryConfig } from '@src/lib/react-query';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

export async function getGoals(): Promise<GetGoalsResponse> {
  const response = await api.get<GetGoalsResponse>('/api/v3/user/goals');
  return response.data;
}

export const getGoalsQueryOptions = queryOptions({
  queryKey: ['goals', 'list'],
  queryFn: getGoals,
});

type UseGetGoalsOptions = {
  queryConfig?: QueryConfig<typeof getGoalsQueryOptions>;
};

export const useGetGoals = ({ queryConfig }: UseGetGoalsOptions = {}) => {
  return useSuspenseQuery({ ...getGoalsQueryOptions, ...queryConfig });
};
